export class Node {
  constructor(public value: any, public next?: Node) {}
}
